import { Icon, IconProps } from '@chakra-ui/react'
import { FC } from 'react'

interface CheckBoxProps extends IconProps {
  isChecked?: boolean
}

const CheckBox: FC<CheckBoxProps> = ({ isChecked, ...rest }) => {
  return (
    <Icon viewBox="0 0 12 12" fill="alabaster" transform="scale(-1,1)" {...rest}>
      {isChecked ? (
        <path
          d="M9.2,12H2.8C1.3,12,0,10.7,0,9.2V2.8C0,1.3,1.3,0,2.8,0h6.4C10.7,0,12,1.3,12,2.8v6.4C12,10.7,10.7,12,9.2,12z M6.8,7.7
      l3.4-3.4L9.1,3.3L5.7,6.7c-0.1,0.1-0.3,0.1-0.4,0L3.5,4.9L2.5,5.9l1.8,1.8C4.6,8.1,5,8.2,5.5,8.2C6,8.2,6.4,8.1,6.8,7.7z"
        />
      ) : (
        <path
          d="M9.2,12H2.8C1.3,12,0,10.7,0,9.2V2.8C0,1.3,1.3,0,2.8,0h6.4C10.7,0,12,1.3,12,2.8v6.4C12,10.7,10.7,12,9.2,12z M9.2,11
	c1,0,1.8-0.8,1.8-1.8V2.8c0-1-0.8-1.8-1.8-1.8H2.8C1.8,1,1,1.8,1,2.8v6.4c0,1,0.8,1.8,1.8,1.8H9.2z"
        />
      )}
    </Icon>
  )
}
export default CheckBox
